<div class="body-container-wrapper">
    <section class="retirement-home-page-banner p-0">
      <div class="container-fluid" style=" margin-bottom: 10px;">
        <div class="row align-items-start">
          <div class="col-md-8 col-sm-12">
            <div class="slider">
              <div class="slides">
                <div class="slide"><img src="../../../assets/images/colormydreams/btech.jpg" alt="Slide 1"  (click)="desktopscroll()"  style="cursor: pointer;"></div>
                <div class="slide"><img src="../../../assets/images/colormydreams/llb.jpg" alt="Slide 2"  (click)="desktopscroll()"  style="cursor: pointer;"></div>
                <div class="slide"><img src="../../../assets/images/colormydreams/mba.jpg" alt="Slide 3"  (click)="desktopscroll()"  style="cursor: pointer;"></div>
                <div class="slide"><img src="../../../assets/images/colormydreams/mbbs.jpg" alt="Slide 4"  (click)="desktopscroll()"  style="cursor: pointer;"></div>

                </div>
                </div>
                </div>
          <!-- Form Section -->
          <div class="col-md-4 col-sm-12">
            <div class="card banner-form">
              <div class="card-body" *ngIf="isLeadFormVisible">
                <h3 class="form-title">Fill out the below form to begin the journey of Coloring Your Child's Dreams!</h3>
                <p id="fill-form" style="color: #ed1b24; display: none;">Fill in all the details to proceed further.</p>
                <form #leadForm="ngForm" (ngSubmit)="PostData(leadForm)">
                  <div class="form-group">
                    <label for="">Name <span class="asterisk">*</span></label>
                    <input type="text" autocomplete="off" id="name" name="name" [(ngModel)]="name" class="form-control"
                      (blur)="removeErrorMsg('name')" placeholder="Please enter your full name" maxlength="40"
                      inputmode="text"
                      oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
                      (keydown)="alphaOnly($event)">
                    <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
                      Invalid full name
                    </div>
                    <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
                      Full name is mandatory
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="">Email Addresss <span class="asterisk">*</span></label>
                    <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();" id="email"
                      name="email" [(ngModel)]="email" class="form-control" placeholder="Your email id" maxlength="50"
                      (blur)="removeErrorMsg('email')">
                    <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
                      Invalid email id
                    </div>
                    <div class="errormsg" *ngIf="emailValidateMessage == 'required'">
                      Email id is mandatory
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="">Mobile Number <span class="asterisk">*</span><span class="asterisk"></span></label>
                    <input type="text" (keydown.space)="$event.preventDefault();" autocomplete="off" id="mobile"
                      name="mobile" [(ngModel)]="mobile" class="form-control" placeholder="Enter Your mobile number"
                      minlength="10" maxlength="10" pattern="[6789][0-9]{9}" (blur)="removeErrorMsg('mobile')"
                      inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      (keypress)="numbersOnly($event)">
                    <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
                      10 digit mobile number is mandatory
                    </div>
                    <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
                      Invalid mobile number
                    </div>
                    <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
                      Mobile number is mandatory
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="">What does your child aspire to become</label>
                    <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();" id="childAspire"
                      name="childAspire" [(ngModel)]="childAspire" class="form-control" placeholder="What does your child aspire to become"
                      inputmode="text"
                      oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
                      (keydown)="alphaOnly($event)">
                  </div>
  
                  <div class="form-group">
                    <label for="">Pincode <span class="asterisk">*</span></label>
                    <input type="text" autocomplete="off" id="pincode" name="pincode" [(ngModel)]="pincode"
                      class="form-control" placeholder="Your pincode" pattern="^[1-9][0-9]{5}$" minlength="6"
                      maxlength="6" (click)="openSuggestionBox($event,'form')" (blur)="hideSuggestionDiv('form')"
                      (keyup)="getPincodeList($event,'form')" (keypress)="numberspincode($event)">
                    <div class="errormsg" *ngIf="pinValidateMessage == 'invalid'">
                      Invalid pincode
                    </div>
                    <div class="errormsg" *ngIf="pinValidateMessage == 'required'">
                      Pincode is mandatory
                    </div>
                    <div class="errormsg" *ngIf="pinValidateMessage == 'notselected'">
                      Pincode selection from the list is mandatory
                    </div>
  
                    <div class="suggestion-box" id="suggestion-box" *ngIf="hideSuggestion">
                      <ng-container *ngFor="let pin of pincodeArr">
                        <a class="pointer" (mousedown)="setpincode(pin,'form')">
                          <div style="padding:10px;">{{pin.pincode}} - {{pin.cityname}}</div>
                        </a>
                      </ng-container>
                    </div>
                  </div>
  
                  <div class="text-left position-relative pl-3">
                    <input type="checkbox" class="form-check-input checkbox2" id="checkout1" [(ngModel)]="checkedTerms"
                      name="check" />
                    <small class="whatsappcontent">
                      By continuing to use this Site/Page, you acknowledge and consent to receiving promotional or
                      sales-related communications from BajajCapital Group. These communications may be sent via phone
                      calls, SMS, WhatsApp, or email, using the contact details you have provided on the Site/Page.
                    </small>
                  </div>
                  <div class="text-center">
                    <button type="submit" class="btn btn-primary" [disabled]="!checkedTerms"
                      (click)="checkValidationMsg(leadForm)">Submit</button>
                  </div>
                </form>
              </div>
              <div class="card-body otp-card" *ngIf="isOtpFormVisible">
                <div id="main_loader" style="display:none;">
                  <div class="loader-wrapper">
                    <div class="lds-roller">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <!-- <h4 class="form-title">Maximize Your Tax Savings Now!</h4> -->
                <form #otpForm="ngForm" (ngSubmit)="SubmitOTP(otpForm)">
                  <p><a href="javascript:void(0)" id="btn-back" (click)="changeNumber()"><i
                        class="fa fa-chevron-left"></i> Change Number</a></p>
                  <div class="alert alert-success">
                    <i class="fa fa-check"></i>
                    <span>OTP successfully sent on number {{displayMobile}}</span>
                  </div>
                  <div class="form-group">
                    <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();"
                      (keyup)="removeErrorMsg('otp')" id="otp" name="otp" [(ngModel)]="userOTP" class="form-control"
                      maxlength="6" placeholder="Enter OTP" (keypress)="numberspincode($event)">
                    <div class="errormsg" *ngIf='!otpVerifiedStatus'>
                      Invalid OTP
                    </div>
                    <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
                      Please enter OTP to continue.
                    </div>
                    <div class="errormsg" *ngIf="otpValidateMessage == 'lengthError'">Invalid OTP
                    </div>
                  </div>
                  <div class="text-center">
                    <button type="submit" class="btn btn-primary" id="otp_verify_btn"
                      (click)="otpValidate()">Submit</button>
                  </div>
                  <div class="form-group text-center">
                    <span *ngIf="isTimer">Didn't recieve OTP? Resend in <strong style="font-size:17px;">{{timeleft}}
                      </strong>seconds</span>
                    <a class="resendotp" href="javascript:void(0)" *ngIf="isResend" (click)="resendOTP()">Resend OTP</a>
                  </div>
                </form>
              </div>
              <div class="card-body success-card" *ngIf="isThanksVisible">
                <div class="success-tick">
                  <h2>Thank you!</h2>
                </div>
                <h6>A member of our care team will get in touch with you shortly.</h6>
              </div>
            </div>
          </div>
          <!-- old form end  -->
        </div>
      </div>
    </section>
  </div>

  <section class="_description">
    <div class="container">
      <p class="_text">Parents aspire to provide their children with a quality professional education, but rising
        inflation can make these dreams seem unachievable</p>
    </div>
  </section>
  <section class="_description2">
    <div class="container">
      <p class="_text">Bajaj Capital encourages you to invest wisely to build a fund for your children’s education.</p>
    </div>
  </section>
  
  <section class="_hashtag">
    <div class="container">
      <h3 class="_heading">#COLORMYDREAMS</h3>
      <div class="row">
        <div class="col-md-6">
          <div class="profile">
            <img src="../../../assets/images/colormydreams/chart/btech.jpg" alt="img" class="user">
            <img src="../../../assets/images/colormydreams/chart/btech.png" alt="img" class="data">
          </div>
        </div>
        <div class="col-md-6">
          <div class="profile">
            <img src="../../../assets/images/colormydreams/chart/MBBS.jpg" alt="img" class="user">
            <img src="../../../assets/images/colormydreams/chart/mbbs.png" alt="img" class="data">
          </div>
        </div>
        <div class="col-md-6">
          <div class="profile">
            <img src="../../../assets/images/colormydreams/chart/MBA.jpg" alt="img" class="user">
            <img src="../../../assets/images/colormydreams/chart/mba.png" alt="img" class="data">
          </div>
        </div>
        <div class="col-md-6">
          <div class="profile">
            <img src="../../../assets/images/colormydreams/chart/LLB.jpg" alt="img" class="user">
            <img src="../../../assets/images/colormydreams/chart/llb.png" alt="img" class="data">
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="section-3" style="background-color: white;">
    <div class="container" style="margin-top: 34px;" style="background-color: white;">
        <h2 class="_heading">Why BajajCapital?</h2>
        <div class="grid-container">
            <div class="column-item">
                <img src="../../../assets/images/colormydreams/Peace of Mind.svg" alt="">
                <h3>Peace of Mind</h3>
                <p>
                  A plan beforehand through us for the bright future of your child accompanied with the right financial steps would ensure 'Peace of Mind' even in the crunchiest of times.
                </p>
                </div>
            <div class="column-item">
                <img src="../../../assets/images/colormydreams/Diversification.svg" alt="">
                <h3>Diversification</h3>
                <p>
                  'Diversification' into different asset classes mitigates the market ups and downs enabling a balanced and stable portfolio growth. At Bajaj Capital we ensure the right mix of asset classes for your ideal portfolio.
                </p>
            </div>
            <div class="column-item">
                <img src="../../../assets/images/colormydreams/Reduced Burden.svg" alt="">
                <h3>Reduced Burden</h3>
                <p>
                  We have especially designed 'Higher Education Solutions' with an investing consistently approach for 10-20 years that can help you build a substantial corpus, thereby easing the financial burden to pay for your child's education.
                </p>
            </div>
            <div class="column-item">
                <img src="../../../assets/images/colormydreams/Flexibility.svg" alt="">
                <h3>Flexibility</h3>
                <p>
                  The Higher Education Solutions keep 'The Power of Compounding' as its core principle hence encouraging an early investment and the flexibility to adjust the portfolio as per your child's education aspirations and market conditions.
                </p>
            </div>
            <div class="column-item">
                <img src="../../../assets/images/colormydreams/Tax Benefits.svg" alt="">
                <h3>Tax Benefits</h3>
                <p>
                  Certain investment options, such as education-focused mutual funds or ELSS, may offer tax benefits, further enhancing the growth of your corpus.
                </p>
            </div>
            <div class="column-item">
                <img src="../../../assets/images/colormydreams/Hedge against Inflation.svg" alt="">
                <h3>Headge against Inflation</h3>
                <p>
                  Early investment can help you stay ahead of rising education costs, which tend to outpace general inflation. Regular Portfolio Rebalancing will allow the right options to grow at a steady pace.
                </p>
            </div>
        </div>
    </div>
</section>


<section id="sipSection" class="financial-calculators" *ngIf="currentCalculator === 'sip'"
  style="margin-top: 10px;background-color: white;">
    <div class="container">
        <div class="row position-relative">
          <div class="col-xl-12 col-lg-12 col-md-12">
             <div class="left">
              <div class="calculator">
                <div class="sip">
                  <div class="number">
                    <h1 class="heading">SIP Calculator</h1>
                     <div class="chips">
                  <a class="badges active" style="cursor:pointer" (click)="showCalculator('sip')">SIP</a>
                  <a class="badges"style="cursor:pointer" (click)="showCalculator('lumsum')">Lumpsum</a>
                </div>
                    <div class="calculators">
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Monthly investment</p>
                          <div class="tooltiped" id="error_msg">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              amount_errormsg
                            }}</span>
                          </div>
                          <div class="placeholder">
                            <i class="fa fa-inr" aria-hidden="true"></i>
                            <input
                              class="range__amount"
                              id="monthlyInput"
                              name="monthlyInput"
                              [(ngModel)]="Monthly_investment"
                              type="number"
                              value="25000"
                              min="500"
                              max="200000"
                              (input)="
                                setInvestmentValue($event);
                                preventInput($event);calculation();updateChartData(chartData)
                              "
                            />
                          </div>
                        </div>
                        <div class="month_range">
                         <div
                              class="calculator-range-slider calculator-custom-range"
                            >
                              <input
                                type="range"
                                name=""
                                step="500"
                                value="25000"
                                class="input-range calc-result-sliders"
                                min="500"
                                max="200000"
                                 id="monthlyRange"
                                [(ngModel)]="Monthly_investment"
                                (input)="monthlyInvestmentRangeVal()"
                                (change)="calculation(); updateChartData(chartData)"
                              />
                              <span
                              class="type-range"
                              [style.width.%]="(P / 200000) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(P / 200000) * 100"
                            ></span>
                            </div>
                          <div class="values">
                            <p class="value">₹500</p>
                            <p class="value">₹2,00,000</p>
                          </div>
                        </div>


                  
                      </div>
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Expected return rate (p.a)</p>
                          <div class="tooltiped" id="error_msg1">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              Expected_Rate_error
                            }}</span>
                          </div>
                          <div class="placeholder reverse">
                            <i class="percent">%</i>
                            <input
                              class="range__amount"
                              id="monthlyexpect"
                              type="number"
                              value="12"
                              min="1"
                              max="30"
                              [(ngModel)]="monthlyexpect"
                              (input)="
                                setRateValue($event);
                                preventInput($event);calculation();updateChartData(chartData)
                              "
                              
                            />
                          </div>
                        </div>
                        <div class="month_range">
                          <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              step="0.1"
                              class="input-range calc-result-sliders"
                              min="1"
                              max="30"
                              id="monthlyrate"
                              [(ngModel)]="monthlyexpect"
                              (input)="monthlyRateRangeVal()"
                              (change)="calculation(); updateChartData(chartData)"
                            />
                            <span
                              class="type-range"
                              [style.width.%]="(R / 30) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(R / 30) * 100"
                            ></span>
                          </div>
                          <div class="values">
                            <p class="value">1%</p>
                            <p class="value">30%</p>
                          </div>
                        </div>
                      </div>
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Time period</p>
                          <div class="tooltiped" id="error_msg2">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              Time_period_error
                            }}</span>
                          </div>
                          <div class="placeholder reverse">
                            <i class="year">Yr</i>
                            <input
                              class="range__amount"
                              id="timeperiod"
                              type="number"
                              value="10"
                              min="1"
                              max="30"
                              [(ngModel)]="timeperiod"
                              (input)="
                                setTimeValue($event);
                                preventInput($event);calculation();updateChartData(chartData)
                              "
                              
                            />
                          </div>
                        </div>
                        <div class="month_range">
                          <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              id="timerange"
                              step="1"
                              value="10"
                              class="input-range calc-result-sliders"
                              min="1"
                              max="30"
                              [(ngModel)]="timeperiod"
                              (input)="monthlyTimeRangeVal()"
                              (change)="calculation(); updateChartData(chartData)"
                            />
                            <span
                              class="type-range"
                              [style.width.%]="(T / 30) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(T / 30) * 100"
                            ></span>
                          </div>
                          <div class="values">
                            <p class="value">1Yr</p>
                            <p class="value">30Yr</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="data">
                    <div class="graph">
                      <ul class="indicators">
                        <li class="amount">Invested amount</li>
                        <li class="return">Est. returns</li>
                      </ul>
                      <div class="graph_img">
                        <canvas id="myChart" width="260px" height="150px"></canvas>
                        <!-- <img src="../../../assets/images/wish-sip/graph.png" class="img-fluid" alt="graph"> -->
                      </div>
                      <div class="values">
                        <ul class="list">
                          <li class="text">Invested amount:</li>
                          <li class="value">
                            ₹{{ total_investment_ammount | conversions }}
                          </li>
                          <li class="text">Est. returns:</li>
                          <li class="value">
                            ₹{{ estmated_return | conversions }}
                          </li>
                        </ul>
                        <ul class="list total">
                          <li class="text">Total value:</li>
                          <li class="value">
                            ₹{{ calculate_value | conversions }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="invest_btn">
                      <a (click)="scrolltop()" style="cursor: pointer;">
                            <img src="../../../assets/images/wish-sip/Connect-Now-Button.png" alt="Invest Now" style="height:80px;" />
                            </a>
                    </div>
                  </div>
                </div>
                <!-- <div class="lumpsum"></div> -->
              </div>
            </div>
          </div>
          </div>
          </div>
          </section>

<section class="_know">
  <div class="container">
    <h3 class="_title">PLAN TODAY TO achieve your dream!</h3>
    <div class="text-center">
      <a (click)="scrolltop()" style="cursor: pointer;" class="btn">Know More</a>
    </div>
    </div>
  <div class="banner-bottom-pane">
    <div class="container">
      <!-- <h4 class="d-md-none">Your Trusted Financial Partner</h4> -->
      <ul id="counter" class="d-flex justify-content-between">
        <li>
          <h2><span class="counter-value" [attr.data-count]='experience'>{{experience}}</span><sup>+</sup> Years</h2>
          <h5>of Experience</h5>
        </li>
        <li>
          <h2>₹<span class="counter-value" [attr.data-count]='asset_under_advisory'>{{asset_under_advisory}}</span><sup>+</sup> Cr</h2>
          <h5>Assets under Management</h5>
        </li>
        <li>
          <h2><span class="counter-value" [attr.data-count]='investors'>{{investors}}</span><sup>+</sup> Lakh</h2>
          <h5>Investors</h5>
        </li>
        <li class="">
          <h2><span class="counter-value" [attr.data-count]='branches'>{{branches}}</span><sup>+</sup></h2>
          <h5>Branches across 100 cities</h5>
        </li>
        <li class="">
          <h2><span class="counter-value" [attr.data-count]='employees'>{{employees}}</span><sup>+</sup></h2>
          <h5>Employees</h5>
        </li>
      </ul>
    </div>
    </div>
</section>

<section class="financial-calculators" *ngIf="currentCalculator === 'lumsum'" style="
    margin-top: 10px;
    background-color: white;
">
    <div class="container">
        <div class="row position-relative">
          <div class="col-xl-12 col-lg-12 col-md-12">      
           <div class="left">
 <div class="calculator">
                <div class="sip">
                  <div class="number">
                    <h1 class="heading">Lumpsum Calculator</h1>
                     <div class="chips">
                  <a class="badges" style="cursor:pointer" (click)="showCalculator('sip')">SIP</a>
                  <a class="badges active" style="cursor:pointer" (click)="showCalculator('lumsum')">Lumpsum</a>
                </div>
                        <div class="calculators">
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Total investment</p>
                          <div class="tooltiped" id="error_msg">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              L_amount_errormsg
                            }}</span>
                          </div>
                          <div class="placeholder">
                            <i class="fa fa-inr" aria-hidden="true"></i>
                            <input
                              class="range__amount"
                              id="monthlyInput"
                              name="monthlyInput"
                              [(ngModel)]="L_Monthly_investment"
                              type="number"
                              value="25000"
                              min="500"
                              max="2000000"
                              (input)="
                                setInvestmentValue2($event);
                                preventInput($event);calculation2();updateChartData2(chartData)
                              "
                            />
                          </div>
                        </div>
                        <div class="month_range">
                         <div
                              class="calculator-range-slider calculator-custom-range"
                            >
                              <input
                                type="range"
                                name=""
                                step="500"
                                value="25000"
                                class="input-range calc-result-sliders"
                                min="500"
                                max="2000000"
                                 id="monthlyRange"
                                [(ngModel)]="L_Monthly_investment"
                                (input)="monthlyInvestmentRangeVal2()"
                                (change)="calculation2(); updateChartData2(chartData)"
                              />
                              <span
                              class="type-range"
                              [style.width.%]="(LP / 2000000) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(LP / 2000000) * 100"
                            ></span>
                            </div>
                          <div class="values">
                            <p class="value">₹500</p>
                            <p class="value">₹20,00,000</p>
                          </div>
                        </div>


                  
                      </div>
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Expected return rate (p.a)</p>
                          <div class="tooltiped" id="error_msg1">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              L_Expected_Rate_error
                            }}</span>
                          </div>
                          <div class="placeholder reverse">
                            <i class="percent">%</i>
                            <input
                              class="range__amount"
                              id="monthlyexpect"
                              type="number"
                              value="12"
                              min="1"
                              max="30"
                              [(ngModel)]="L_monthlyexpect"
                              (input)="
                                setRateValue2($event);
                                preventInput($event);calculation2();updateChartData2(chartData)
                              "
                              
                            />
                          </div>
                        </div>
                        <div class="month_range">
                          <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              step="0.1"
                              class="input-range calc-result-sliders"
                              min="1"
                              max="30"
                              id="monthlyrate"
                              [(ngModel)]="L_monthlyexpect"
                              (input)="monthlyRateRangeVal2()"
                              (change)="calculation2(); updateChartData2(chartData)"
                            />
                            <span
                              class="type-range"
                              [style.width.%]="(LR / 30) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(LR / 30) * 100"
                            ></span>
                          </div>
                          <div class="values">
                            <p class="value">1%</p>
                            <p class="value">30%</p>
                          </div>
                        </div>
                      </div>
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Time period</p>
                          <div class="tooltiped" id="error_msg2">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              L_Time_period_error
                            }}</span>
                          </div>
                          <div class="placeholder reverse">
                            <i class="year">Yr</i>
                            <input
                              class="range__amount"
                              id="timeperiod"
                              type="number"
                              value="10"
                              min="1"
                              max="30"
                              [(ngModel)]="L_timeperiod"
                              (input)="
                                setTimeValue2($event);
                                preventInput($event);calculation2();updateChartData2(chartData)
                              "
                              
                            />
                          </div>
                        </div>
                        <div class="month_range">
                          <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              id="timerange"
                              step="1"
                              value="10"
                              class="input-range calc-result-sliders"
                              min="1"
                              max="30"
                              [(ngModel)]="L_timeperiod"
                              (input)="monthlyTimeRangeVal2()"
                              (change)="calculation2(); updateChartData2(chartData)"
                            />
                            <span
                              class="type-range"
                              [style.width.%]="(LT / 30) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(LT / 30) * 100"
                            ></span>
                          </div>
                          <div class="values">
                            <p class="value">1Yr</p>
                            <p class="value">30Yr</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="data">
                    <div class="graph">
                      <ul class="indicators">
                        <li class="amount">Invested amount</li>
                        <li class="return">Est. returns</li>
                      </ul>
                      <div class="graph_img">
                        <canvas id="myChart" width="260px" height="150px"></canvas>
                        <!-- <img src="../../../assets/images/wish-sip/graph.png" class="img-fluid" alt="graph"> -->
                      </div>
                      <div class="values">
                        <ul class="list">
                          <li class="text">Invested amount:</li>
                          <li class="value">
                            ₹{{ L_total_investment_ammount | conversions }}
                          </li>
                          <li class="text">Est. returns:</li>
                          <li class="value">
                            ₹{{ L_estmated_return | conversions }}
                          </li>
                        </ul>
                        <ul class="list total">
                          <li class="text">Total value:</li>
                          <li class="value">
                            ₹{{ L_calculate_value | conversions }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="invest_btn">
                            <a (click)="scrolltop()" style="cursor: pointer;">
                            <img src="../../../assets/images/wish-sip/Connect-Now-Button.png" alt="Invest Now" style="height:80px;" />
                            </a>
                    </div>
                  </div>
                </div>
                <!-- <div class="lumpsum"></div> -->
              </div>
            </div>
      
          </div>
        </div>
    </div>

</section>


    <div class="container">
        <p class="col-md-12 mt-3 terms"> <span style="font-weight: bold;">Disclaimer: </span>Bajaj Capital Limited (“BCL”) is a mutual fund distributor (ARN 0010) registered with AMFI. Certain products and services offered by BCL may not be traded on the exchange. All disputes with respect to the distribution activity, would not have access to Exchange Investor Redressal Forum or Arbitration mechanism. In accordance with the applicable laws, BCL is allowed to render incidental advice with respect to mutual fund products only to its mutual fund distribution clients. For every other purpose, including distribution of non-mutual fund products, the circulated material is for informational purposes only. Further, it is not intended as investment advice or an opinion concerning securities or a public offer proving a basis for an investment decision. The views or expressions contained in the circulated material are not necessarily of BCL and BCL neither assumes any responsibility/liability nor does guarantee its accuracy, suitability, completeness, and adequacy. The figures and data that may be appearing in the material are taken from various sources and BCL is not responsible for the accuracy of the same. The content of the material including images, charts, graphics, and pictures are protected intellectual properties and cannot be amended, copied, reproduced, replicated, republished, uploaded, posted, published, transmitted, displayed, or distributed for any non-personal use without obtaining prior written permission, any non-adherence of which may attract appropriate legal action. <strong>Mutual Fund investments are subject to market risk, read all scheme-related documents carefully.</strong> The past performance of the scheme is not indicative of future performance. Investors are advised to seek appropriate advice from experts before taking any investment decisions. Nothing in the circulated material is intended to construe an advertisement or an investment, financial advice and/or solicitation, advice to buy, sell or deal in any financial product.
         
          <br><br>

          <span style="font-weight: bold;">*Note: </span>
          The costs are conservative and are bound to vary from university to university.
         
          <br>       

        <span style="font-weight: bold;">** </span>
          The figures provided represent approximate estimates of educational costs. Actual costs may vary based on the institution and other factors
        
          <br>

        <span style="font-weight: bold;">***Source: </span>
          https://economictimes.indiatimes.com/news/india/the-cost-of-raising-a-child-in-india-school-costs-30-lakh-college-a-crore/articleshow/93607066.cms?from=mdr

        </p>
        
    </div>